var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgStar(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 33,
    viewBox: "0 0 35 33"
  }, props), React.createElement("path", {
    fill: "#FFA203",
    fillRule: "evenodd",
    d: "M34.44 14.166c1.068-.873.516-2.584-.882-2.657l-9.722-.583a1.527 1.527 0 01-1.327-.946L18.936.955c-.515-1.273-2.32-1.273-2.836 0l-3.572 8.989c-.221.546-.736.91-1.326.947l-9.76.583c-1.398.072-1.95 1.782-.883 2.655l7.55 6.115c.442.363.663.982.515 1.528l-2.467 9.352c-.331 1.311 1.105 2.366 2.283 1.638l8.213-5.204c.515-.327 1.142-.327 1.62 0l8.248 5.204c1.179.728 2.616-.327 2.284-1.638l-2.468-9.317a1.488 1.488 0 01.554-1.491l7.55-6.15z"
  }));
}

export default SvgStar;